import { render, staticRenderFns } from "./StudentProfileCard.vue?vue&type=template&id=7ecc4b35&scoped=true&"
import script from "./StudentProfileCard.vue?vue&type=script&lang=js&"
export * from "./StudentProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileCard.vue?vue&type=style&index=0&id=7ecc4b35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ecc4b35",
  null
  
)

export default component.exports